const menus = [
  {
    id: '/',
    text: 'Beranda',
    icon: 'mdi-home',
    to: '/',
    roles: []
  },
  {
    id: 'surat-masuk',
    text: 'Surat Masuk',
    icon: 'mdi-email',
    to: 'surat-masuk',
    roles: []
  },
  {
    id: 'surat-masuk-pimpinan',
    text: 'Surat Masuk Pimpinan',
    icon: 'mdi-email-outline',
    to: 'surat-masuk-pimpinan',
    roles: ['Sekpri']
  },
  {
    id: '2',
    text: 'Surat Keluar',
    icon: 'mdi-send',
    to: 'surat-keluar',
    roles: []
  },
  {
    id: 'agenda',
    text: 'Agenda',
    icon: 'mdi-calendar',
    to: 'agenda',
    roles: []
  }
]

export default menus
